(function (angular) {
    'use strict';

    angular.module('shared')
        /**
         *
         */
        .controller('RegisterCtrl', ['$cookies', '$scope', 'jwtService', 'sharedDataService', '$location', '$stateParams', 'signUpService', 'growlService', '$state', '$timeout', 'utilService', 'emailDomainValidationService',
            function ($cookies, $scope, jwtService, sharedDataService, $location, $stateParams, signUpService, growlService, $state, $timeout, utilService, emailDomainValidationService) {

                jwtService.clear();
                sharedDataService.clearCache();
                $scope.sections = [
                    {
                        name: "Register",
                        value: "register"
                    },
                    {
                        name: "Provide Phone Number",
                        value: "providePhoneNumber"
                    },
                    {
                        name: "Phone Code",
                        value: "providePhoneCode"
                    }
                ];
                $scope.currentSection = $scope.sections[0];
                $scope.newUser = {};
                $scope.user = {};

                if ($location.search().user) {
                    $scope.newUser.email = $location.search().user;
                }

                if ($stateParams.userData) {
                    var userData = $stateParams.userData;
                    $scope.newUser = {
                        accountId: userData.accountId,
                        userId: userData.userId,
                        verifyKey: userData.verifyKey,
                        password: userData.password,
                        email: userData.email,
                        verificationOnly: true
                    };
                    growlService.success("Your Account isn't active. Please finish registration process");
                    $scope.currentSection = $scope.sections[1];
                }

                $scope.validatePassword = function () {
                    if ($scope.newUser.password) {
                        if ($scope.newUser.password.length >= 8) {
                            if ($scope.newUser.password.toLowerCase() != $scope.newUser.password && $scope.newUser.password.toUpperCase() != $scope.newUser.password) {
                                if ($scope.newUser.password.match(/\d+/g) !== null) {
                                    if (/^[a-zA-Z0-9- ]*$/.test($scope.newUser.password)) {
                                        $scope.passwordValidationMessage = "Password should contain at least one special char";
                                    }
                                    else {
                                        return false;
                                    }
                                }
                                else {
                                    $scope.passwordValidationMessage = "Password should contain at least one number";
                                }
                            }
                            else {
                                $scope.passwordValidationMessage = "Password should contain at least one capital and one lower case letter";
                            }
                        }
                        else {
                            $scope.passwordValidationMessage = "Password should be at least 8 characters long";
                        }
                        return true;
                    }
                    return false;
                };

                $scope.validateEmail = function () {

                    if (emailDomainValidationService.validateEmail($scope.newUser.email)) {

                        if (emailDomainValidationService.validateDomain($scope.newUser.email)) {
                            return true;
                        } else {
                            $scope.emailValidationMessage = "Please enter your business email address. This form does not accept addresses from free email domains";
                            return false;
                        }
                    } else {
                        $scope.emailValidationMessage = "This doesn't look like a valid email address";
                        return false;
                    }
                };


                $scope.containOnlyNumbers = function (value) {
                    if (value && value.charAt(0) == '+') {
                        value = value.substr(1);
                    }
                    return /^\d+$/.test(value);
                };

                $scope.signup = function () {
                    signUpService.createNewAccount({ userName: $scope.newUser.email, password: $scope.newUser.password, email: $scope.newUser.email })
                        .then(function (result) {
                            $scope.newUser.accountId = result.accountId;
                            $scope.newUser.userId = result.userId;
                            $scope.newUser.verifyKey = result.verifyKey;
                            $scope.currentSection = $scope.sections[1];
                        }).
                        catch(function (error) {
                            if (error.status == 400 && error.data.validationFailures) {
                                for (var i in error.data.validationFailures) {
                                    var validationFailure = error.data.validationFailures[i];
                                    if (validationFailure.paramName == "userName" || validationFailure.paramName == "email") {
                                        $scope.validationError = {
                                            message: "Account with this email already exist"
                                        };
                                    }
                                }
                            }
                            else {
                                growlService.danger("Registration problem due to: " + error.statusText);
                            }
                        });
                };

                $scope.providePhoneNumber = function () {
                    var phone = $scope.newUser.phone;
                    if (phone.charAt(0) == '+') {
                        phone = phone.substr(1);
                    }
                    signUpService.providePhoneNumber($scope.newUser.accountId, $scope.newUser.userId, { phoneNumber: phone, verifyKey: $scope.newUser.verifyKey })
                        .then(function (result) {
                            $scope.verifyId = result.verifyId;
                            $scope.currentSection = $scope.sections[2];
                        })
                        .catch(function (error) {
                            if (error.status == 400 && error.data && error.data.validationFailures && error.data.validationFailures.length > 0) {

                                var msg = utilService.formatValidationErrors(error.data.validationFailures);

                                growlService.danger(msg, 0);
                            }
                            else {
                                growlService.danger("Registration problem due to: " + error.status + " " + error.statusText + ". Try providing code again");
                            }

                        });

                };
                $scope.providePhoneCode = function () {
                    signUpService.provideVerifyCode($scope.newUser.accountId, $scope.newUser.userId, { verifyId: $scope.verifyId, code: $scope.newUser.phoneCode, verifyKey: $scope.newUser.verifyKey }).then(function (result) {
                        if (!$scope.newUser.verificationOnly && $scope.newUser.email && $scope.newUser.password) {
                            $scope.user.userId = $scope.newUser.email;
                            $scope.user.password = $scope.newUser.password;
                            $state.go('thanks', { user: $scope.newUser.email, pass: $scope.newUser.password });
                        }
                        else if ($scope.newUser.verificationOnly && $scope.newUser.email && $scope.newUser.password) {
                            jwtService.login($scope.newUser.email, $scope.newUser.password)
                                .then(function (result) {

                                    if ($stateParams.link && $stateParams.link != '/login') $location.path($stateParams.link);
                                    else $location.path("/home");
                                })
                                .catch(function (error) {
                                    sharedDataService.spinning = true;
                                    $timeout(function () {
                                        jwtService.login($scope.newUser.email, $scope.newUser.password)
                                            .then(function (result) {
                                                sharedDataService.spinning = false;
                                                if ($stateParams.link && $stateParams.link != '/login') $location.path($stateParams.link);
                                                else $location.path("/home");
                                            })
                                            .catch(function (error) {
                                                sharedDataService.spinning = false;
                                                $state.go('login', { user: $scope.newUser.email });
                                            });
                                    }, 3000);
                                });
                        }
                        else {
                            $state.go('login', { user: $scope.newUser.email });
                        }
                    })
                        .catch(function (error) {
                            if (error.status == 400 && error.data && error.data.validationFailures && error.data.validationFailures.length > 0) {
                                var msg = utilService.formatValidationErrors(error.data.validationFailures);
                                growlService.danger(msg, 0);
                            }
                            else {
                                growlService.danger("Registration problem due to: " + error.statusText + ". Try providing code again");
                            }

                        });
                };
            }]);

})(window.angular);